<template>
  <div id="shop_all">
    <bio-shop-top :name="active"></bio-shop-top>
    <div class="shop_box">
      <div class="left_nav">
        <router-link
          tag="div"
          :to="item.path"
          class="left_nav_div"
          :class="item.title ===  active  ? 'left_nav_click' : '' "
          v-for="(item,index) in leftnav"
          :key="index"
        >
          <span>{{item.title}}</span>
        </router-link>
      </div>
      <div class="shop_content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import BioShopTop from "./bioShopTop";

export default {
  components: { BioShopTop },
  data() {
    return {
      leftnav: [],
      active: ""
    };
  },
  watch: {
    "$store.state.leftnav": {
      handler: function(newer) {
        this.leftnav = newer;
      },
      deep: true
    },
    "$store.state.shop_left": {
      handler: function(newer) {
        this.active = newer;
      },
      deep: true
    }
    // '$route' : function(val){
    //   window.console.log(val)
    // }
  },
  // activated(){
  //   window.console.log(1)
  // },
  mounted() {
    // this.active  = this.$store.state.shop_left
  }
};
</script>
<style lang="scss">
#shop_all {
  background: #f5f5f5;
  min-height: 1000px;
}
.shop_box {
  display: flex;
}
.left_nav {
  width: 180px;
  background: rgba(226, 232, 241, 1);
  min-height: 674px;
  .left_nav_div {
    height: 40px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    text-align: center;
    line-height: 40px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    cursor: pointer;
  }
  .left_nav_div:hover {
    background: rgba(255, 255, 255, 1);
    color: rgba(0, 153, 255, 1);
  }
  .left_nav_click {
    background: rgba(255, 255, 255, 1);
    color: rgba(0, 153, 255, 1);
  }
}
.shop_content {
  width: 1060px;
  // height: 500px;
  margin: 26px auto 0 auto;
}
</style>